import { Check } from "lucide-react";

import { Button } from "@design-lab/shared/ui/design-system/Button";

type PinApprovalCardProps = {
  onApprove: () => void;
  onReject: () => void;
  isApproving: boolean;
  isRejecting: boolean;
  isLoading?: boolean;
  compact?: boolean;
};

export function PinApprovalCard({
  onApprove,
  onReject,
  isApproving,
  isRejecting,
  isLoading,
  compact = false
}: PinApprovalCardProps) {
  const isDisabled = isApproving || isRejecting || !!isLoading;

  return (
    <div
      className={`rounded-[10px] bg-[#F6EDFF] ${compact ? "p-2" : "p-3"}`}
      data-testid="pinning-image-approval"
    >
      <p className="text-[10px] font-bold uppercase tracking-wide text-[#9225FF]">
        AI Preview Ready
      </p>
      <p className={`mt-1 font-semibold text-gray-900 ${compact ? "text-xs" : "text-sm"}`}>
        Does this look right?
      </p>
      <p className={`mt-0.5 text-gray-900 ${compact ? "text-xs" : "text-sm"}`}>
        Toggle the image above to compare.
      </p>
      <div className={`flex gap-2 ${compact ? "mt-2" : "mt-3"}`}>
        <Button
          data-testid="pinning-reject-image"
          variant="outline"
          size="sm"
          className={compact ? "flex-1 bg-white" : "bg-white px-3.5"}
          onPress={onReject}
          isDisabled={isDisabled}
        >
          {isRejecting ? "Sending\u2026" : "No, send to Human Artist"}
        </Button>
        <Button
          data-testid="pinning-approve-image"
          size="sm"
          className={
            compact
              ? "flex-1 bg-[#00834F] text-white hover:bg-[#006B40]"
              : "bg-[#00834F] px-3.5 text-white hover:bg-[#006B40]"
          }
          onPress={onApprove}
          isDisabled={isDisabled}
        >
          <Check className="h-4 w-4" />
          {isApproving && !isRejecting ? "Saving\u2026" : "Yes, Save"}
        </Button>
      </div>
    </div>
  );
}
